var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.params) ? _c('el-dialog', {
    staticClass: "scoped-interivew-email",
    attrs: {
      "title": _vm.senderTitle,
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPreview),
      expression: "!isPreview"
    }],
    key: _vm.renderKey,
    staticClass: "editView"
  }, [_c('div', {
    staticStyle: {
      "width": "85%",
      "margin": "0px auto 20px"
    }
  }, [_c('p', [_vm._v("已勾选" + _vm._s(_vm.params.length) + "条数据")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.dataList
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "供应商",
      "width": "100",
      "prop": "supplierName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "定薪数量",
      "width": "80",
      "prop": "supplierName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.rpIdList.length))]
      }
    }], null, false, 3940408418)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "对接人(点击名字标签可不发送给该对接人)",
      "prop": "users"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.contactList), function(item, index) {
          return _c('el-tag', {
            key: index,
            staticClass: "user-tag",
            class: {
              'disabled': item.disabled === true
            },
            nativeOn: {
              "click": function($event) {
                return _vm.togglerUserActive(item)
              }
            }
          }, [_vm._v(_vm._s(item.name) + "(" + _vm._s(item.email) + ")")])
        })
      }
    }], null, false, 311185674)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100",
      "prop": "number"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.previewEmail(scope.row)
            }
          }
        }, [_vm._v("预览")])]
      }
    }], null, false, 643718374)
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择模板",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择模板",
      "clearable": ""
    },
    on: {
      "change": _vm.renderEmailTemplate
    },
    model: {
      value: (_vm.emailTemplate),
      callback: function($$v) {
        _vm.emailTemplate = $$v
      },
      expression: "emailTemplate"
    }
  }, _vm._l((_vm.emailTemplateList), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮件标题",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "maxlength": 200,
      "placeholder": "请输入邮件标题"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收件人",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('user-group', {
    ref: "recipients",
    attrs: {
      "allowEmail": true
    },
    model: {
      value: (_vm.recipients),
      callback: function($$v) {
        _vm.recipients = $$v
      },
      expression: "recipients"
    }
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "position": "absolute",
      "right": "-40px",
      "top": "0px"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.previewEmailByRecipients()
      }
    }
  }, [_vm._v("预览")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "抄送人",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('user-group', {
    ref: "ccList",
    attrs: {
      "allowEmail": true
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "附件",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('file-upload', {
    staticClass: "upload-desc",
    attrs: {
      "action": ((_vm.$axios.defaults.baseURL) + "/payment/template/fileInsert.api")
    },
    model: {
      value: (_vm.fileList),
      callback: function($$v) {
        _vm.fileList = $$v
      },
      expression: "fileList"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮件内容",
      "label-width": _vm.formLabelWidth
    }
  }, [(_vm.placeHolders.length) ? _c('div', {
    staticClass: "quickTool"
  }, _vm._l((_vm.placeHolders), function(item, key) {
    return _c('el-tag', {
      key: key,
      attrs: {
        "icon": "el-icon-plus",
        "size": "small"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.$refs.editor.addAfterCursor(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1) : _vm._e(), _vm._v(" "), _c('vueditor', {
    ref: "editor",
    model: {
      value: (_vm.form.contentCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "contentCode", $$v)
      },
      expression: "form.contentCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.isPreview) ? _c('div', {
    staticClass: "previewView"
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "1px solid #ddd"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("邮件标题：" + _vm._s(_vm.form.name))]), _vm._v(" "), _c('p', [_vm._v("收件人："), _vm._l((_vm.interviewerUsers), function(item, index) {
    return (item.disabled !== true) ? _c('span', {
      key: item.id
    }, [_vm._v(_vm._s(item.name)), _c('span', [_vm._v(";")])]) : _vm._e()
  })], 2), _vm._v(" "), _c('p', [_vm._v("抄送人："), _vm._l((_vm.form.ccList), function(item, index) {
    return _c('span', {
      key: item.id
    }, [_vm._v(_vm._s(item.name)), _c('span', [_vm._v(";")])])
  })], 2), _vm._v(" "), (_vm.fileList.length) ? _c('p', [_vm._v("附件："), _vm._l((_vm.fileList), function(item) {
    return _c('span', {
      key: item.fileId
    }, [_vm._v(_vm._s(item.fileName || item.name) + ";")])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px solid #ddd",
      "padding-top": "10px"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.form.content)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.isPreview) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]) : _vm._e(), _vm._v(" "), (_vm.isPreview) ? _c('el-button', {
    staticClass: "left",
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.toEditView
    }
  }, [_vm._v("返 回")]) : _vm._e(), _vm._v(" "), (!_vm.isPreview) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("发 送")]) : _vm._e()], 1)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-051324bc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/salaryEmailDialog.vue
// module id = null
// module chunks = 